<template>
    <div class="container-fluid">
        <v-title :lineage="[{'Automations':'automations'}]">
            Webhooks
            <div slot="actions">
                <router-link
                    v-if="$auth.$pages['add-webhook'].isAllowed"
                    :to="{name: 'add-webhook'}"
                    class="btn btn-link">Add Webhook<v-icon class="margin-left-xs" icon="arrow-right"/></router-link>
            </div>
        </v-title>
        <div class="grid">
            <div class="grid-item">
                <grid
                    :columns="gridColumns"
                    :provider="provider"
                    :tabs="gridTabs"
                    @completed="stopLoadingPage">
                    <v-no-content slot="no-content">
                        <span slot="title">It seems that you have no webhooks</span>
                        <span slot="description">Click on the button below to add your first webhook.</span>
                        <div slot="actions">
                            <router-link
                                v-if="$auth.$pages['add-webhook'].isAllowed"
                                :to="{name: 'add-webhook'}"
                                class="btn btn-link">Add Webhook<v-icon class="margin-left-xs" icon="arrow-right"/></router-link>                        </div>
                    </v-no-content>
                </grid>
            </div>
        </div>
    </div>
</template>

<script>
    import vTitle from '@/components/v-title';
    import {vIcon} from '@/components/form';
    import vNoContent from '@/components/v-no-content';
    import Grid from '@/components/grid/grid';
    import LoadStateMixin from '@/mixins/load-state-mixin';
    import TabsConfiguration from '@/components/grid/tabs/tabs-configuration';
    import FILTER_TYPES from '@/components/query/filter-types';
    import webhookColumns from './webhook-columns';

    export default {
        name: 'webhooks',
        components: {
            vTitle, vIcon, Grid, vNoContent,
        },
        mixins: [LoadStateMixin],
        data() {
            return {
                gridColumns: webhookColumns(this.testWebhook),
                gridTabs: new TabsConfiguration({
                    id: 'webhook-list',
                    store: this.$store,
                    systemTabs: [
                        {
                            label: 'All',
                            sortBy: {createdTime: 'desc'},
                        },
                        {
                            label: 'Active',
                            filter: [['status', ['active'], FILTER_TYPES.text]],
                            sortBy: {processedTime: 'desc'},
                        },
                    ],
                    version: 2,
                }),
            };
        },
        methods: {
            async testWebhook(data, btn) {
                try {
                    btn.setAttribute('disabled', 'disabled');
                    const params = {
                        data: {
                            eventsFilter: data.fields.eventsFilter,
                            status: data.fields.status,
                            method: data.fields.method,
                            headers: data.fields.headers,
                            url: data.fields.url,
                            credentialHash: data.fields.credentialHash,
                        },
                    };
                    await this.$api(({previews}) => previews.webhook(params));
                    this.$toast.positive('Webhook successfully sent');
                } catch (error) {
                    this.$toast.fromError(error);
                } finally {
                    btn.removeAttribute('disabled');
                }
            },
            provider(params) {
                return this.$api(({webhooks}) => webhooks.getAll(params));
            },
        },
    };
</script>
